import React from 'react';
import classnames from 'classnames';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { isNotEmpty } from '@intelligence/v3/utils/common';

interface IFilterGroupProps extends IBaseProps {
  groupKey: string;
  title?: string;
  icon?: string;
  children?: React.ReactNode;
}

const generateGroupClassNameModifier = (groupKey?: string): string => {
  if (!groupKey) {
    return '';
  }

  const convertedGroupKey = groupKey.replace(/_/g, '-');

  return `dbi-filter-group--${convertedGroupKey}`;
};

const FilterGroup: React.FC<IFilterGroupProps> = (props) => {
  const { style, className, groupKey, title, icon, children } = props;

  const { formatMessage } = useIntlExtend();

  const validChildren = React.Children.toArray(children).filter((child: any) => {
    return child !== false && isNotEmpty(child);
  });

  if (validChildren.length === 0) {
    return null;
  }

  const hasTitleIcon = isNotEmpty(icon);
  const groupTitle = formatMessage({ id: title });
  const groupClassNameModifier = generateGroupClassNameModifier(groupKey);

  return (
    <div
      style={style}
      className={classnames('dbi-filter-group', className, groupClassNameModifier, {
        'dbi-filter-group--with-title-icon': hasTitleIcon,
      })}
    >
      {!!groupTitle && (
        <div className="dbi-filter-group__title">
          {hasTitleIcon && <img className="dbi-filter-group__title-icon" src={icon} alt="" />}
          <span className="dbi-filter-group__title-text">{groupTitle}</span>
        </div>
      )}
      <div className="dbi-filter-group__content">{validChildren}</div>
    </div>
  );
};

export default FilterGroup;
